import { mapActions, mapMutations } from 'vuex';

export default {
  data() {
    return {
      showModalCodeEditor: false,
    };
  },

  methods: {
    ...mapActions('jStoreFormUi', [
      'actionGetDetailForm', 'actionGetDetailMultiForm', 'actionSetForm',
      'actionSetMultiForm', 'actionGetDetailFormData',
    ]),
    ...mapMutations('jStoreFormUi', ['setChangesValueView']),

    openModalCodeEditor() {
      this.showModalCodeEditor = true;
      this.$refs.modalCodeEditor.show();
    },

    closeModalCodeEditor() {
      this.$refs.modalCodeEditor.hide();
      this.showModalCodeEditor = false;
    },

    updateViewByCode(data, type) {
      this.$swal({
        title: 'Update',
        text: `Are you sure to update ${this.formDetail.name}?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Update',
        confirmButtonColor: '#42a5ce',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          let res;
          const params = this._.cloneDeep(this.formDetail);
          params[type] = data;
          if (!this.isMultipleForm) {
            res = await this.actionSetForm(params);
          } else {
            res = await this.actionSetMultiForm(params);
          }
          if (!res.error) {
            this.setChangesValueView(false);
            const dataFilter = {
              id: [this.$route.params.id],
            };
            const param = {
              limit: 0,
              page: 1,
              filter: JSON.stringify(dataFilter),
            };
            if (!this.isMultipleForm) {
              await this.actionGetDetailForm(param);
            } else {
              await this.actionGetDetailMultiForm(param);
            }
          }

          this.closeModalCodeEditor();
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form-ui-v2/jMixCodeEditorPerView.js